import React from 'react'
import './Fridge.css'
import fridgeImg from '../../luniImages/fullFridge_3.jpeg'

import Logo from '../Logo'
import Mint from '../Mint'
import Team from '../Team'
import Roadmap from '../Roadmap'
import Stable from '../Stable'
import Holders from '../Holders'
import Staking from 'components/Staking'
import Headlock from 'components/Headlock'

export default function Fridge() {
    return (
        <div className="fridge">
            <div
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    background: '#ffe587',
                    padding: '5px 10px',
                    display: 'flex',
                    justifyContent: 'center',
                }}
            >
                <div>
                    Mint Gullible Seagulls{' '}
                    <a
                        href="https://seagulls.naturalborndegenz.art"
                        target="_blank"
                        rel="noreferrer"
                    >
                        here
                    </a>
                </div>
            </div>
            <Logo />
            <img src={fridgeImg} alt="fridge" className="fridge__img" />
            <Mint />
            <Stable />
            <Headlock />
            <Staking />
            <Team />
            <Roadmap />
            <Holders />
        </div>
    )
}
